import { render, staticRenderFns } from "./ResumHoresPeriode.vue?vue&type=template&id=4855f0e2&scoped=true&"
import script from "./ResumHoresPeriode.vue?vue&type=script&lang=js&"
export * from "./ResumHoresPeriode.vue?vue&type=script&lang=js&"
import style0 from "./ResumHoresPeriode.vue?vue&type=style&index=0&id=4855f0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4855f0e2",
  null
  
)

export default component.exports